import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

class NativeCarousel210x196 extends React.Component {
  render() {
    const { pagedetails } = this.props;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    const bannerDetail = pagedetails.bannerImageDetails;
    if (bannerDetail === undefined) {
      return null;
    }
    const slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 1
    };

    const arr = [];

    bannerDetail.map((bannerimagedetails, j) => {
      arr.push({
        id: j,
        uId: bannerimagedetails.uId,
        imageUrl: bannerimagedetails.imageUrl,
        urlLink: bannerimagedetails.bannerUrlLink,
        bannerPos: bannerimagedetails.bannerPosition,
        componentPos: bannerimagedetails.componentPosition
      });
    });

    const imageGallery = arr.map((data, i) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        data.imageUrl.indexOf('?') == -1
          ? data.imageUrl
          : data.imageUrl.substr(0, data.imageUrl.indexOf('?'));
      return (
        <Col xs={3} key={i} className="gallery-section">
          <a
            href={data.urlLink}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${data.componentPos}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${data.bannerPos}`}
            data-gtm-bnr-position={`${data.componentPos}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(data.imageUrl) || ''}`}
            data-gtm-bnr-id={`${data.uId || ''}`}
            className="img-animate"
          >
            <img src={`${replaceWithJioCDN(data.imageUrl)}`} />
          </a>
        </Col>
      );
    });

    let imageList;

    if (arr.length > 4) {
      imageList = (
        <Slider {...slickSettings} ref="slick">
          {imageGallery}
        </Slider>
      );
    } else {
      imageList = imageGallery;
    }
    const classNames = `gallery-com${arr.length <= 4 ? ' row' : ''}`;

    return <div className={classNames}>{imageList}</div>;
  }
}

export default BannerWrapper(NativeCarousel210x196);
